import React, {useContext} from 'react'
import {PurchaseContext} from "../../../context/PurchaseContext";
import {Col, Row} from "antd";

const PurchaseMidTotal = () => {
    const {memoizeCurrencyTotals} = useContext(PurchaseContext)


    return (
        <React.Fragment>
            <div style={{marginTop: '16px'}}>
                <Row justify={'end'}>
                    <Col span={3}>
                        <span className={'font-bold'}>Ara Toplam</span>
                    </Col>
                    <Col span={3}>
                        {
                            Object.keys(memoizeCurrencyTotals).map(key => {
                                const currencyItem = memoizeCurrencyTotals[key]
                                const total = currencyItem.reduce((a, b) => a + b, 0)
                                return (
                                    <p key={key}><span className={'font-bold'}>{key}: </span>{new Intl.NumberFormat().format(total)}</p>
                                )
                            })
                        }
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}
export default PurchaseMidTotal